const headerStyle = () => {
    if (screen.width > 993) {
        if( $(window).scrollTop() > 2 ) {
            $('.header').addClass('header--fixed');
        } else {
            $('.header').removeClass('header--fixed');
        }
    }
}

$(document).on('scroll', function(){
    headerStyle();
})

$(document).on('ready', function() {
    headerStyle();
})
